
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
    aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavDropdown" >
    <ul class="nav nav-pills">
      <li class="nav-item" >
        <a class="nav-link " routerLink="home" routerLinkActive ="active">
          <span class="menu-item-parent">Principal</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="isPJOuCpfComOutorga()">
        <a class="nav-link" routerLink="cadastra-maquina" routerLinkActive ="active">
          <span class="menu-item-parent">Cadastrar Máquina</span>
        </a>       
      </li>
      <li class="nav-item" *ngIf="isPJOuCpfComOutorga()">
        <a class="nav-link" routerLink="consulta-maquina" routerLinkActive ="active">
          <span class="menu-item-parent">Consultar Máquina</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript: void(0)" (click)="abrirManual()" routerLinkActive ="active">
          <span class="menu-item-parent">Ajuda</span>
        </a>
      </li>
    </ul>
  </div>
  <div class="btn-group dropleft botoesMsgPerfil" *ngIf="!isEmpresaOutorgante && !isCertToken">
    <button class="btn btn-outline-primary " 	(click)="openDialogTrocarOutorga()" type="button" aria-haspopup="true" aria-expanded="false">
      <div class="corIcone">
        <img class="img-fluid" src="assets/icons/people_alt.png"  width="28px"/>
      </div>
      <div class="fonteSize">
        Acessar Empresa Outorgante
      </div>
    </button>
  </div>
  <div class="btn-group dropleft botoesMsgPerfil" *ngIf="isEmpresaOutorgante">
    <button class="btn btn-outline-primary " 	(click)="sairOutorga()" type="button" aria-haspopup="true" aria-expanded="false">
      <div class="corIcone">
        <img class="img-fluid" src="assets/icons/people_alt.png"  width="28px"/>
      </div>
      <div class="fonteSize">
        Sair Empresa Outorgante
      </div>
    </button>
  </div>
</nav>